import React from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import { useTranslations } from '@libs/translations';
import { DEFAULT_LOCALE, PRIMARY_LANG } from '@constants/langs';

export const CustomLink = ({
  href = '',
  link = '#',
  translateKey = '',
  useHtmlTranslateKey = false,
  usePushRoute = false,
  children,
  onClick,
}) => {
  const router = useRouter();
  const translations = useTranslations();
  const { locale } = useSelector((state) => state.settings);
  const { pathname } = router;

  if (usePushRoute) {
    const onClick = () => {
      router
        .push(
          {
            pathname: href,
          },
          href,
          {
            locale: href === '/' && locale === PRIMARY_LANG.value ? DEFAULT_LOCALE : locale,
          }
        )
        .then(() => window.scrollTo(0, 0));
    };

    return <>{React.cloneElement(children, { onClick })}</>;
  }

  const isPrimaryHomePage = pathname === '/' && (locale === PRIMARY_LANG.value || locale === DEFAULT_LOCALE);

  if (href) {
    // если мы на основной главной - используем обычные ссылки <a></a>, потому что иначе подставляется фейковая локаль
    if (isPrimaryHomePage) {
      const linkHref = `/${locale}${href}`;

      return (
        <>
          {useHtmlTranslateKey ? (
            <a href={linkHref} onClick={onClick} dangerouslySetInnerHTML={{ __html: translations.t(translateKey) }} />
          ) : (
            <a href={linkHref} onClick={onClick}>
              {translations.t(translateKey)}
              {children}
            </a>
          )}
        </>
      );
    } else {
      return (
        <Link href={`/${locale}${href}`} as={`/${locale}${href}`} locale={false} onClick={onClick}>
          {useHtmlTranslateKey ? (
            <a dangerouslySetInnerHTML={{ __html: translations.t(translateKey) }} />
          ) : (
            <a>
              {translations.t(translateKey)}
              {children}
            </a>
          )}
        </Link>
      );
    }
  } else {
    return (
      <>
        {useHtmlTranslateKey ? (
          <a href={link} dangerouslySetInnerHTML={{ __html: translations.t(translateKey) }} onClick={onClick} />
        ) : (
          <a href={link} onClick={onClick}>
            {translations.t(translateKey)}
            {children}
          </a>
        )}
      </>
    );
  }
};
